'use client';

import React, { createContext, useContext } from 'react';

const BuilderUrlContext = createContext<string>('');

export const useBuilderUrl = () => useContext(BuilderUrlContext);

export function BuilderUrlProvider({ url, children }: { url: string; children: React.ReactNode }) {
  return <BuilderUrlContext.Provider value={url}>{children}</BuilderUrlContext.Provider>;
}
